import React, { useEffect, useRef, useState } from 'react';
import { branch, googlePlayStoreLink } from '../../../Constants/branchUrls';
import {
  getCartItems,
  getScreenName,
  showNewCartFlow,
} from '../../../Utils/helper';
import { goToCartHandler } from '../../../Utils/productAction';
import ArticleProductCard from '../../ArticlePage/ArticalProductCard/ArticleProductCard';
import DownloadAppBanner from '../../ArticlePage/DownloadAppBanner/DownloadAppBanner';
import { ProductsMayLikeSection } from '../../ArticlePage/RelatedArticlesNew/styled';
import RelatedArticleTopics from '../../ArticlePage/RelatedTopics/RelatedArticleTopics';
import Loader from '../../Loader';
import { SnackBar } from '../../Product/PdpHeader/styled';
import AskNow from '../../QnaPage/AskNowSection/AskNow';
import { StickySection } from '../../QnaPage/AskNowSection/styled';
import Breadcrumbs from '../../StoreCategoryPage/Breadcrumbs';
import CategoryBanner from '../CategoryBanner';
import { TopicDetailGrid } from '../CategoryBanner/styled';
//import { installAppLinks } from "../common";
import DiscoverTopics from '../DiscoverTopics/DiscoverTopics';
import PopularTools from '../PopularTools/PopularTools';
import TabsCardData from '../RelatedTopicSection/TabsCardData';
import TopicInfoCard from '../TopicInfo/TopicInfoCard';
import { TopicContentGrid } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';
// const DesktopInstallNotif = dynamic(
//     () => import("../../QnaPage/DesktopInstallNotif/DesktopInstallNotif"),
//     {
//         ssr: false,
//     },
// );

export default function NewTopicDesign(props) {
  let {
    tagId,
    tagData,
    toolsData,
    generalTabsName,
    generalTabsData,
    updatedGeneralTabData,
    addedToCart,
    setAddedToCart,
    generalTabsProductsData,
  } = props;
  const [showCartSnackBar, setShowCartSnackBar] = useState(false);
  //const [showDesktopNotifPopup, setShowDesktopNotifPopup] = useState(false);
  const snackBarTimeoutRef = useRef(null);
  const [showFullLoader, setShowFullLoader] = useState();
  //const [branchUrl, setBranchUrl] = useState();
  const installLink = googlePlayStoreLink;
  const cartItems = getCartItems();
  const getMultipleItems = () => {
    let items = [];
    generalTabsProductsData?.items?.map((element) => {
      if (element?.itemType == 'MULTIPLE_ITEMS') {
        items = [...element?.items];
      }
    });
    return items;
  };
  const productsArray = getMultipleItems();

  useEffect(() => {
    setAddedToCart(false);
    if (addedToCart && !showNewCartFlow()) {
      clearTimeout(snackBarTimeoutRef.current);
      setShowCartSnackBar(true);
      snackBarTimeoutRef.current = setTimeout(() => {
        setShowCartSnackBar(false);
      }, 3000);
    }
  }, [addedToCart]);

  const cartCtaHandler = () => {
    fireEvent({
      category: 'clicked_go_to_cart_in_snackbar',
      screen_name: getScreenName(),
      item_count: cartItems.length || 0,
      id: cartItems.pop(),
    });
    goToCartHandler();
  };

  // useEffect(() => {
  //     getBranchParameters();
  // }, []);
  // const getBranchParameters = async () => {
  //     const { branchUrl, appInstalledOrNot } = await appCheck();
  //     setBranchUrl(branchUrl);
  // };
  return (
    <>
      <SnackBar className={showCartSnackBar ? 'show' : ''}>
        ADDED TO CART SUCCESSFULLY{' '}
        <span onClick={cartCtaHandler}>GO TO CART</span>
      </SnackBar>
      {showFullLoader && <Loader />}
      {/* {showDesktopNotifPopup ? (
                <DesktopInstallNotif
                    installLink={installLink}
                    contentId={tagId}
                    contentType={"topic"}
                    contentData={[tagData?.name]}
                    showDesktopNotifPopup={showDesktopNotifPopup}
                    showInstallNotifCard={false}
                    setShowDesktopNotifPopup={setShowDesktopNotifPopup}
                />
            ) : null} */}

      {tagData?.breadcrumbs?.length && (
        <Breadcrumbs breadCrumbs={tagData?.breadcrumbs} />
      )}
      <TopicDetailGrid>
        <StickySection>
          <DiscoverTopics />
          <AskNow
            installLink={installLink}
            description={tagData?.description}
            //setShowDesktopNotifPopup={setShowDesktopNotifPopup}
          />
        </StickySection>
        <section className="mobileTopSection">
          <CategoryBanner pageType={'topic'} banner={tagData?.image} />
          <TopicContentGrid>
            <div className="mWebPadding">
              <TopicInfoCard
                installLink={branch?.main_follow_cta_topic_page}
                tagData={tagData}
              />
              <TabsCardData
                updatedGeneralTabData={updatedGeneralTabData}
                generalTabsName={generalTabsName}
                tagId={tagId}
                setShowFullLoader={setShowFullLoader}
              />
              <DownloadAppBanner installLink={branch?.download_banner} />
            </div>
            <div>
              <RelatedArticleTopics
                pageType={'question'}
                topics={generalTabsData?.outerGeneralItems?.[0]?.items}
              />
              <PopularTools toolsData={toolsData} />
            </div>
          </TopicContentGrid>
        </section>
      </TopicDetailGrid>
      <ProductsMayLikeSection>
        {' '}
        <ArticleProductCard
          setAddedToCart={setAddedToCart}
          productArray={productsArray}
        />
      </ProductsMayLikeSection>
    </>
  );
}
